import CultureResources from "utilities/interfaces/culture-resources";

enum UserCollectionShareType {
    User = 0,
    WorkGroup = 1,
    Team = 2,
}

export const UserCollectionShareTypeValueToNameMap: {
    [key: string]: keyof CultureResources;
} = {
    [UserCollectionShareType.User]: "privateCollections",
    [UserCollectionShareType.WorkGroup]: "sharedWithWorkgroups",
    [UserCollectionShareType.Team]: "sharedWithEntireTeam",
};

export default UserCollectionShareType;
